<template>
  <v-dialog max-width="500" @click:outside="closeModal">
    <v-card class="h-auto bg-white font-inter" :loading="loading">
      <div class="w-full relative">
        <img
          src="../../../assets/icon/background-pattern.png"
          alt="background-pattern"
          loading="lazy"
          class="w-52 h-auto absolute top-0 -left-[2px]"
        />
        <div class="flex justify-between pb-3 pt-[10px] pl-2 pr-4">
          <div class="">
            <div class="p-2 bg-red-200 rounded-full w-fit">
              <div class="p-3 bg-red-600 rounded-full">
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  class="rotate-90"
                >
                  <path
                    d="M12 3a9 9 0 0 0-9 9 9.005 9.005 0 0 0 4.873 8.001L6 20a1 1 0 0 0-.117 1.993L6 22h4a1 1 0 0 0 .993-.883L11 21v-4a1 1 0 0 0-1.993-.117L9 17l-.001 1.327A7.006 7.006 0 0 1 5 12a7 7 0 0 1 14 0 1 1 0 1 0 2 0 9 9 0 0 0-9-9Zm0 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
                    fill="#DDE6E8"
                  />
                </svg>
              </div>
            </div>
            <div class="ml-3">
              <h3 class="mt-3 text-slate-900 font-semibold text-lg relative">
                Konfirmasi Rollback Data
              </h3>
              <h5 class="font-normal text-sm">
                Apakah anda yakin ingin mengembalikan data bulan
                <b>{{ data.month_year }}</b> area <b>{{ data.area }}</b> dengan
                nama kontraktor
                <b>{{ data.contractor_name }}.</b>
              </h5>
            </div>
          </div>
          <i
            @click="closeModal"
            class="mdi mdi-close text-2xl cursor-pointer text-gray-500"
            id="modal_icon_click_close"
          ></i>
        </div>
      </div>
      <v-form ref="formData" class="px-5 pb-5">
        <label for="form_input_rollback" class="text-sm font-medium">
          Catatan
        </label>
        <v-textarea
          variant="outlined"
          id="form_input_rollback"
          auto-grow
          color="#475569"
          v-model="note"
          :rules="formValidasi.message"
        ></v-textarea>

        <div class="grid grid-cols-2 gap-3">
          <v-btn
            @click="closeModal"
            id="modal_btn_click_close"
            variant="outlined"
            class="text-none"
          >
            Batal
          </v-btn>
          <v-btn
            @click="doSave"
            id="modal_btn_click_submit"
            color="red darken-1"
            class="text-none"
            :disabled="loading"
          >
            Simpan
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import util from "@/assets/js/util";
import { FormValdasiDataRollback } from "../core/FormData";
import { StatusEnum, JenisNotifEsgEnum } from "@/utilities/enum";
import axios from "axios";
import {
  APP_BACKEND_ESG,
  API_BASE_URL,
  CMS_NOTIFICATION_ESG,
} from "@/constants";

const base_url = APP_BACKEND_ESG;
const url_send_notifcation = API_BASE_URL + CMS_NOTIFICATION_ESG;

export default {
  name: "RollbackModal",
  data() {
    return {
      formValidasi: FormValdasiDataRollback,
      note: null,
      loading: false,
    };
  },
  props: {
    data: Object,
    userData: Object,
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
      this.note = null;
    },
    async doSave() {
      try {
        const validate = await this.$refs.formData.validate();
        if (validate.valid) {
          this.loading = true;
          let bodyJson = {
            id: parseInt(this.data.id),
            status: StatusEnum.REVISION,
            approved_by: this.userData.name,
            note: this.note,
          };

          const response = await axios.post(
            `${base_url}/esg/validate`,
            bodyJson,
          );
          await this.sendNotification(this.note, this.data);
          util.showInfo(response.data.message);
        }
      } catch (err) {
        util.showError(err);
        this.loading = false;
      } finally {
        this.loading = false;
        this.$emit("after-submit");
      }
    },
    async sendNotification(note, data) {
      try {
        let bodyJson = {
          kontraktorId: parseInt(data.id_contractor),
          infoReport: data.month_year,
          note: note,
          adminEnviro: this.userData.name,
          jenisNotification: JenisNotifEsgEnum.ADMIN_ROLLBACK,
          workArea: data.area,
          idMonth: parseInt(data.month),
          year: data.year,
          id: parseInt(this.data.id),
        };

        await axios.post(`${url_send_notifcation}`, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
      } catch (error) {
        console.error("Error sending notification:", error);
      }
    },
  },
};
</script>
